import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import HomeRepository from '@/repositories/homeRepository';
import NewsRepository from '@/repositories/newsRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useHomeStore = defineStore({
    id: 'home',
    state: () => ({
        Menu1: [],
        Menu2: [],
        List: [],
    }),
    getters: {},
    actions: {
        async resetHomeStore() {
            this.Menu1 = [];
            this.Menu2 = [];
            this.List = [];
        },
        /**
         * メニュー取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getMenuAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const homeRepository = new HomeRepository();
            try {
                const response = await homeRepository.getMenuApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                // ユーザー情報をstoreに格納
                this.Menu1 = response.data.CustomMenuSetting.Menu1;
                this.Menu2 = response.data.CustomMenuSetting.Menu2;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * お知らせ一覧取得API
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getNewsListAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const newsRepository = new NewsRepository();
            try {
                const response = await newsRepository.getNewsListApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                // ユーザー情報をstoreに格納
                this.List = response.data.List;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * 新着情報確認APIをコールする。
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getNewArrivalAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const homeRepository = new HomeRepository();
            try {
                // 新着情報確認APIをコールする。
                const response = await homeRepository.getNewArrivalApi(API_URL, requestBody, idToken);

                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        //ローカルストレージに保存する場合
        // storage: localStorage
        storage: sessionStorage,
    },
});
